var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlusWhiteBlueCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 16.5C34 20.8761 32.2089 25.0729 29.0208 28.1673C25.8327 31.2616 21.5087 33 17 33C12.4913 33 8.1673 31.2616 4.97919 28.1673C1.79107 25.0729 0 20.8761 0 16.5C0 12.1239 1.79107 7.92709 4.97919 4.83274C8.1673 1.73839 12.4913 0 17 0C21.5087 0 25.8327 1.73839 29.0208 4.83274C32.2089 7.92709 34 12.1239 34 16.5ZM18.0625 9.28125C18.0625 9.00775 17.9506 8.74544 17.7513 8.55205C17.552 8.35865 17.2818 8.25 17 8.25C16.7182 8.25 16.448 8.35865 16.2487 8.55205C16.0494 8.74544 15.9375 9.00775 15.9375 9.28125V15.4688H9.5625C9.28071 15.4688 9.01046 15.5774 8.8112 15.7708C8.61194 15.9642 8.5 16.2265 8.5 16.5C8.5 16.7735 8.61194 17.0358 8.8112 17.2292C9.01046 17.4226 9.28071 17.5312 9.5625 17.5312H15.9375V23.7188C15.9375 23.9923 16.0494 24.2546 16.2487 24.448C16.448 24.6413 16.7182 24.75 17 24.75C17.2818 24.75 17.552 24.6413 17.7513 24.448C17.9506 24.2546 18.0625 23.9923 18.0625 23.7188V17.5312H24.4375C24.7193 17.5312 24.9895 17.4226 25.1888 17.2292C25.3881 17.0358 25.5 16.7735 25.5 16.5C25.5 16.2265 25.3881 15.9642 25.1888 15.7708C24.9895 15.5774 24.7193 15.4688 24.4375 15.4688H18.0625V9.28125Z",
    fill: "#367FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlusWhiteBlueCircle);
export default __webpack_public_path__ + "static/media/icon-plus-white-blue-circle.9bc05a9a751c1fcfa9a9bb644460f070.svg";
export { ForwardRef as ReactComponent };